import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Description from 'src/components/Product/Desktop/ProductBottomBar/Description';
import StepButton from 'src/components/Product/Desktop/ProductBottomBar/StepButton';
import { BottomBar } from 'src/components/Product/Desktop/ProductBottomBar/styles';
import { useDecodedParams } from 'src/hooks/useDecodedParams';
import { RepairDetailContext } from 'src/providers/repairs/RepairDetails';
import { isWithinIframe } from 'src/services/checkForIframe';
import { workInstructionsLink } from 'src/utils/urls';
import { stepUrls } from '../../Shared/Helpers/stepUrls';

interface ProductParams {
  productId: string;
  section: string;
}

export function ProductBottomBar() {
  const repairDetails = useContext(RepairDetailContext);
  const { productId, section } = useDecodedParams<ProductParams>();
  const { search } = useLocation();
  const { t } = useTranslation('workInstructions');

  if (!repairDetails) {
    return null;
  }

  const { step, repair } = repairDetails;

  const { nextStepUrl, prevStepUrl } = stepUrls(repair, step);
  const repairsHome = workInstructionsLink(productId);
  const currentRepairStart = workInstructionsLink(productId, section);

  const prevStepURL = `${prevStepUrl}${search}`;
  const nextStepURL = `${
    isWithinIframe ? /* istanbul ignore next */ nextStepUrl || currentRepairStart : nextStepUrl || repairsHome
  }${search}`;

  return (
    <BottomBar data-testid="repair-bar">
      <StepButton
        icon={faChevronLeft}
        to={prevStepURL || /* istanbul ignore next */ '#'}
        disabled={!prevStepUrl}
        hideOnTablet
        data-testid="prev-step-button"
      >
        {t('repairStep.prevStep')}
      </StepButton>
      <Description description={step.description} />
      <StepButton icon={faChevronRight} to={nextStepURL} data-testid="next-step-button">
        {nextStepUrl ? t('repairStep.nextStep') : t('repairStep.complete')}
      </StepButton>
    </BottomBar>
  );
}
